"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row,
      _ref$extraData = _ref.extraData,
      extraData = _ref$extraData === void 0 ? {} : _ref$extraData;
    var enumOptions = extraData[settings.optionsPath];
    var displayValue = ((0, _get2["default"])(enumOptions ? enumOptions.find(function (option) {
      return (0, _get2["default"])(option, settings.valuePath) === value;
    }) : row, settings.labelPath) || '').toString();
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: row
    }, value ? /*#__PURE__*/_react["default"].createElement("div", null, "".concat(settings.prefix || '').concat(displayValue).concat(settings.suffix || '')) : /*#__PURE__*/_react["default"].createElement("div", null));
  };
};